import React from 'react';

interface CommonGridProps {
    title: string;
    value: string | number;

}

const CommonGrid: React.FC<CommonGridProps> = ({ title, value }) => {
    return (
        <>
        <div className="group space-y-2 cursor-pointer rounded-xl text-center px-6 pt-6 pb-4 transition hover:-translate-y-0.5">
          <p className="text-sm font-medium text-ez-text-secondary transition group-hover:text-ez-text-primary">{title}</p>
          <div className="flex items-center justify-center w-14 h-14 mx-auto rounded-full bg-violet-500/15 text-violet-500 dark:text-violet-400 text-xl font-bold ring-1 ring-violet-500/30 dark:ring-violet-400/30 transition group-hover:bg-violet-500/25 dark:bg-violet-500/10">
              {value}
          </div>
        </div>
      </>

    );
};

export default CommonGrid;
